import React from 'react';

export const TablePreview = ({ component, onClick, isSelected }) => {
  const { commonAttrs, specificAttrs } = component;
  const { columns, data } = specificAttrs || {};
  const columnsArray = (columns || 'Column 1,Column 2').split(',');
  const rowsArray = (data || 'Row 1 Col 1,Row 1 Col 2|Row 2 Col 1,Row 2 Col 2').split('|').map(row => row.split(','));
  
  const containerStyle = {
    padding: `${commonAttrs?.paddingTop || 16}px ${commonAttrs?.paddingRight || 16}px ${commonAttrs?.paddingBottom || 16}px ${commonAttrs?.paddingLeft || 16}px`,
    margin: `${commonAttrs?.marginTop || 8}px ${commonAttrs?.marginRight || 0}px ${commonAttrs?.marginBottom || 8}px ${commonAttrs?.marginLeft || 0}px`,
    width: commonAttrs?.width === 'auto' ? 'auto' : `${commonAttrs?.width || 100}%`,
    cursor: onClick ? 'pointer' : 'default',
    border: isSelected ? '2px solid #3B82F6' : '2px solid transparent',
    borderRadius: '4px'
  };
  
  return (
    <div style={containerStyle} onClick={onClick}>
      <table style={{
        width: '100%',
        borderCollapse: 'collapse',
        fontSize: '14px',
        border: '1px solid #E5E7EB'
      }}>
        <thead>
          <tr style={{ background: '#F3F4F6' }}>
            {columnsArray.map((col, idx) => (
              <th key={idx} style={{
                padding: '10px',
                textAlign: 'left',
                fontWeight: '600',
                borderBottom: '2px solid #D1D5DB'
              }}>
                {col.trim()}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rowsArray.map((row, rowIdx) => (
            <tr key={rowIdx} style={{ borderBottom: '1px solid #E5E7EB' }}>
              {row.map((cell, cellIdx) => (
                <td key={cellIdx} style={{ padding: '10px' }}>
                  {cell.trim()}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
